import { jsx as _jsx } from "react/jsx-runtime";
import NoAccessToPage from '@web/pages/layout/NoAccessToPage/NoAccessToPage';
import { useHasScope } from '@web/utility/hooks/useHasScope';
import React from 'react';
export var CanAccess = function (_a) {
    var scope = _a.scope, children = _a.children;
    var hasAccess = useHasScope(scope);
    if (hasAccess) {
        return children;
    }
    return null;
};
export var CanAccessToPage = function (_a) {
    var scope = _a.scope, children = _a.children;
    var hasAccess = useHasScope(scope);
    if (hasAccess) {
        return children;
    }
    return _jsx(NoAccessToPage, {});
};
